import { api } from '../../../App';
import { fromEmailWithPhoneToGenerated } from '../../../parsers/to-generated/emailWithPhone.parser';

export const enrollForReceipt = async (phone: string, email: string, token: string) => {
  const emailWithPhoneDto = fromEmailWithPhoneToGenerated(email, phone);
  await api.enrollment.apiEnrollReceiptPost(token, emailWithPhoneDto);
};
